import React, { Component } from "react";
import { Badge, Button, Form } from "react-bootstrap";
import { IsEmailValid } from "../../helpers/Helpers";

export default class InviteOwnerForm extends Component {
    state = {
        isInvalid: false,
    };

    onSubmit = (event) => {
        const form = event.currentTarget;
        const email = form["email"].value;
        
        event.preventDefault();
        event.stopPropagation();
        this.setState({
            isInvalid: false,
        })

        if (!IsEmailValid(email)) {
            this.setState({
                isInvalid: true,
            })
            return;
        }

        this.props.inviteOwner(email);
        form.reset();
    };

    getOwnersEmailsList() {
        const currentUserId = this.props.currentUserId;
        return this.props.otherOwners.filter(owner => owner._id !== currentUserId);
    }

    render() {
        const { isPrimaryOwner, deleteOwner } = this.props;
        const { isInvalid } = this.state;
        const ownersEmailsList = this.getOwnersEmailsList();

        return (
            <>
                <Form
                    noValidate
                    onSubmit={this.onSubmit}
                    className="d-flex align-items-start justify-content-between mb-4 mt-2"
                >
                    <Form.Group
                        controlId="email"
                        className="my-0 w-75 position-relative"
                    >
                        <Form.Control
                            plaintext
                            type="text"
                            placeholder="Email..."
                            required
                            className="my-0 w-100"
                            isInvalid={isInvalid}
                        />
                        <Form.Control.Feedback
                            type="invalid"
                            className="ml-2 position-absolute"
                            style={{ bottom: -15, fontSize: 10 }}
                        >
                            Please enter a valid email.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Button
                        variant="primary"
                        type="submit"
                        className="rounded-sm"
                        style={{ width: '20%' }}
                    >
                        + Add
                    </Button>
                </Form>
                <div className="d-flex flex-wrap ml-2">
                    {ownersEmailsList?.length > 0 && ownersEmailsList.map(owner => (
                        <Badge key={owner._id} className="badge-custom py-2 px-3 mr-1 mb-2" pill>
                            {owner.email}
                            {isPrimaryOwner && <span 
                                className="ml-3"
                                style={{ cursor: 'pointer' }}
                                onClick={() => deleteOwner(owner.email)}
                            >
                                x
                            </span>}
                        </Badge>
                    ))}
                </div>
            </>
        )
    }
}